export enum ToastPositionEnum {
  TOP = 'top',
  TOP_START = 'top-start',
  TOP_END = 'top-end',
  CENTER = 'center',
  CENTER_START = 'center-start',
  CENTER_END = 'center-end',
  BOTTOM = 'bottom',
  BOTTOM_START = 'bottom-start',
  BOTTOM_END = 'bottom-end',
}
